import React, {useEffect, useState} from 'react';

import {Button} from 'react-bootstrap';

import {getDelayProfile} from '@/api/delayProfileApi';
import {getSambaUser as getSambaUserApi} from '@/api/sambaUserApi';
import StandalonePopUp from '@/components/popup/StandalonePopUp';
import {ResponseData} from '@/constants/dataEnum';
import HTTPStatusCode from '@/constants/httpStatusCode';
import * as APPDATA from '@/constants/pcConstAppData';

function DataCollectionPopup() {
  const [popUp, setPopUp] = useState({
    popUpVisible: false,
    popUpTitle: '',
    popUpText: '',
    popUpButton: undefined,
    hideCloseButton: false,
  });

  useEffect(() => {
    getSambaUser();
  }, []);

  const getSambaUser = () => {
    getSambaUserApi().catch(async (err) => {
      if (err.response.status === HTTPStatusCode.NOT_FOUND) {
        const response = await getDelayProfile();
        if (response?.data === ResponseData.NOT_FOUND) {
          if (err.response.data === ResponseData.NO_USER_FOUND) {
            dataCollectionModal();
          }
        }
      }
    });
  };

  const goToSettingPage = () => {
    closePopUp();
    window.location.href = APPDATA.GENERAL_SETTING_ADDRESS;
  };

  const dataCollectionModal = () => {
    const popUpButton = [
      {
        id: APPDATA.SET_LATER,
        label: APPDATA.SET_LATER,
        isPrimaryButton: false,
        onClick: closePopUp,
      },
      {
        id: APPDATA.SET_UP_NOW,
        label: APPDATA.SET_UP_NOW,
        isPrimaryButton: true,
        onClick: goToSettingPage,
      },
    ];

    const newPopUp = {
      popUpVisible: true,
      popUpTitle: APPDATA.MESSAGES.DATA_COLLECTION.AUTHENTICATION_SETUP_POPUP.TITLE,
      popUpText: APPDATA.MESSAGES.DATA_COLLECTION.AUTHENTICATION_SETUP_POPUP.TEXT,
      popUpButton,
      hideCloseButton: true,
    };

    setPopUp(newPopUp);
  };

  const closePopUp = () => {
    const newPopUp = {
      popUpVisible: false,
      popUpTitle: '',
      popUpText: '',
      popUpButton: undefined,
    };

    setPopUp(newPopUp);
  };

  const generateButton = () => {
    const button = popUp.popUpButton
      ? popUp.popUpButton.map((button) => {
          // eslint-disable-next-line no-nested-ternary
          const classButton = button.isPrimaryButton
            ? `primaryButton no-outline ${button.className}`
            : button.className
            ? `${button.className} no-outline `
            : 'secondaryButton no-outline ';
          return (
            <Button
              id={button.id}
              key={button.id}
              bsSize="large"
              className={classButton}
              onClick={button.onClick}
              disabled={button.disabled}
            >
              {button.label.toUpperCase()}
            </Button>
          );
        })
      : '';
    return button;
  };

  return (
    <StandalonePopUp
      isPopUpVisible={popUp.popUpVisible}
      contents={{
        popUpTitle: popUp.popUpTitle,
        popUpBody: popUp.popUpText,
        popUpFooter: (
          <div className="row">
            <div className="buttondiv">{generateButton()}</div>
          </div>
        ),
      }}
      onClose={closePopUp}
      hideCloseButton={popUp.hideCloseButton}
    />
  );
}

export default DataCollectionPopup;
